import http from "../http-common";

class NotaService {
  getAll(params = {}) {
    return http.get("/notas", { params });
  }

  get(id) {
    return http.get(`/notas/${id}`);
  }

  getStudentsByGradeCycle(gradeId, cycleId) {
    return http.get("/notas/students-by-grade-cycle", {
      params: { grade_id: gradeId, cycle_id: cycleId }
    });
  }

  getCursosForStudent(studentId, gradeId) {
    return http.get(`/notas/student/${studentId}/cursos`, {
      params: { grade_id: gradeId }
    });
  }

  getNotasByAsignment(asignmentId) {
    return http.get(`/notas/asignment/${asignmentId}`);
  }

  create(data) {
    return http.post("/notas", data);
  }

  update(id, data) {
    return http.put(`/notas/${id}`, data);
  }

  delete(id) {
    return http.delete(`/notas/${id}`);
  }

  getStudentsList(params) {
    return http.get('/notas/students-list', { params });
  }

  generatePdf(asignmentId) {
    return http.get(`/notas/asignment/${asignmentId}/pdf`, {
      responseType: 'blob',
    });
  }

  generateBulkPdf(data) {
    return http.post('/notas/bulk-pdf', data, {
      responseType: 'blob',
    });
  }
}

export default new NotaService();
